import httpClient from './httpClient';

export const SKU_ENDPOINT = '/backoffice/products/sku';

export const getProductBySKUAPI = (params) => httpClient.get(`${SKU_ENDPOINT}`, { params });
